import React from "react";
import { useQuery } from "@apollo/client";
import { Row, Col } from "react-bootstrap";
import { PieChart, Pie, Cell, Legend } from "recharts";
import { GET_ACTIVE_SIGNIFICANT_DEFICIENCIES } from "../../../queries/archiveQrys/secureQrys/enfDashboardQrys";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import ErrorHandler from "../../reuseableComponents/ErrorHandler";

const colors = ["#108c4f", "#a40606", "#d2b307"];

const ActiveSignificantDeficiencies = () => {
  const { loading, error, data } = useQuery(GET_ACTIVE_SIGNIFICANT_DEFICIENCIES);

  if (loading)
    return (
      <>
        <h3>Active Significant Deficiencies</h3>
        <SkeletonLoader width='100%' />
      </>
    );

  if (error) return <ErrorHandler error={error} />;

  if (!data)
    return (
      <>
        <h3>Active Significant Deficiencies</h3>
        <span>No Data Returned</span>
      </>
    );
  if (error)
    return (
      <>
        <h3>Active Significant Deficiencies</h3>
        <span>Something went wrong</span>
      </>
    );
  const RADIAN = Math.PI / 180;
  const renderCustomLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 1.05;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text x={x} y={y} fill='black' textAnchor={x > cx ? "start" : "end"} dominantBaseline='central'>
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

  return (
    <React.Fragment>
      <Row>
        <Col>
          <h3>Active Significant Deficiencies</h3>
        </Col>
      </Row>
      <Row>
        <Col cypressid='activeSigDefLegend'>
          <Legend
            wrapperStyle={{ position: "relative" }}
            payload={data.getActiveSignificantDeficiencies.map((item, index) => ({
              id: item.name,
              value: `${item.name}: ${item.value}`,
              color: colors[index % colors.length]
            }))}
            iconSize={0}
            verticalAlign='top'
            align={"left"}
            style={{ position: "relative" }}
          />
        </Col>
      </Row>
      <Row>
        <Col cypressid='activeSigDefPieChart'>
          <PieChart width={375} height={325}>
            <Pie
              data={data.getActiveSignificantDeficiencies}
              cx='55%'
              cy='60%'
              labelLine={false}
              label={renderCustomLabel}
              dataKey='value'
            >
              {data.getActiveSignificantDeficiencies.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
              ))}
            </Pie>
          </PieChart>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default ActiveSignificantDeficiencies;
